import React, {Component} from 'react';
import axios from "axios";
import Select from "react-select";
import Button from "react-bootstrap/Button";

import classes from'./GroupsInput.module.css';
import NewGroup from "../NewGroup/NewGroup";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import apiUrl from "../../../shared/config";

/**
 * THIS COMPONENT IS FOR ADDING A USER TO A GROUP
 * THERE IS ANOTHER 'GroupInput' COMPONENT THAT IS FOR
 * ADDING A GROUP TO A PATTERN, OR A GROUP TO THE SEARCHBAR
 * THAT COMPONENT IS IN THE UI FOLDER
 */
class GroupsInput extends Component  {
    state = {
        groups: [],
        group_user_types: [],
        selected_groups: [],
        new_group: false
    };

    componentDidMount() {
        if (this.state.groups !== []) {
            axios.get(apiUrl +'Groups/getGroups')
                .then(response => {
                    this.setState({groups: response.data});
                });
        }
        this.setState({selected_groups: this.props.groups});

        if (this.state.group_user_types !== []) {
            axios.get(apiUrl +'GroupUserTypes/getGroupUserTypes')
                .then(response => {
                    this.setState({group_user_types: response.data});
                });
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps !== this.props) {
            this.setState({selected_groups: this.props.groups})
        }
    }

    addGroup = () => {
        this.setState(
            {selected_groups: [
                    ...this.state.selected_groups,
                    {
                        group_id: null,
                        group_user_type_id: null,
                        group_manager: 0
                    }]
            });
    };

    newGroupToggle = () => {
        this.setState({new_group: !this.state.new_group});
    };

    newGroupsHandler = (new_group) => {
        axios.get(apiUrl +'Groups/getGroups')
            .then(response => {
                this.setState({
                    groups: response.data,
                    selected_groups: [...this.state.selected_groups, new_group]
                })
            });
    };

    arraySearch(arr,val) {
        for (let i = 0; i < arr.length; i++) {
            if (arr[i].value === val)
                return i;
        }
        return -1;
    }

    render() {
        let groupsInputElement = null;
        if (this.state.groups && this.state.groups.length) {
            const groupOptions = this.state.groups
                .map( group => ({value: group.group_id, label: group.group_name, isDisabled: false}));

            const groupUserTypeOptions = this.state.group_user_types
                .map( group_user_type => ({value: group_user_type.group_user_type_id, label: group_user_type.group_user_type_name}));

            if (this.state.selected_groups && this.state.selected_groups.length) {
                let groups_index = 0;
                let selected_groups = [...this.state.selected_groups];
                groupsInputElement = (
                    <>
                        <dd className="col-sm-12">
                            {selected_groups.map(group => {
                                let groups_index_local = groups_index;
                                const group_id = selected_groups[groups_index_local].group_id;
                                const default_index = this.arraySearch(groupOptions, group_id);
                                let default_value = {label: "Select a group to join."};
                                if (group_id !== null) {
                                    default_value = groupOptions[default_index];
                                }
                                // const group_user_type_id = selected_groups[groups_index_local].group_user_type_id;
                                // const default_group_user_type_index = this.arraySearch(groupUserTypeOptions, group_user_type_id);
                                // let default_group_user_type_value = {label: "What is your role in this group?"};
                                // if (group_user_type_id !== null && groupUserTypeOptions[default_group_user_type_index] !== undefined) {
                                //     default_group_user_type_value = groupUserTypeOptions[default_group_user_type_index];
                                // }
                                let group_manager_checkbox = '';
                                if (selected_groups[groups_index_local].group_manager) {
                                    group_manager_checkbox = (
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={(!!selected_groups[groups_index_local].group_manager)}
                                                    onChange={(event) =>
                                                        {
                                                            let groups_local = [...selected_groups];
                                                            groups_local[groups_index_local] = {
                                                                ...groups_local[groups_index_local],
                                                                group_manager: selected_groups[groups_index_local].group_manager === 1 ? 0 : 1
                                                            };
                                                            this.setState({selected_groups: groups_local});
                                                            this.props.groupsUpdate(groups_local);
                                                        }
                                                    }
                                                    name="auto_join"
                                                    color="primary"
                                                />
                                            }
                                            label="Manage this group."
                                        />
                                    );
                                }

                                const group_jsx = (
                                    <div className={classes.GroupBlock} key={group_id + " " + groups_index}>
                                        <Select
                                            className={classes.GroupSelect}
                                            defaultValue={{
                                                value: selected_groups[groups_index_local].group_id,
                                                label: default_value.label,
                                                isFixed: true,
                                                isDisabled: true
                                            }}
                                            options={groupOptions}
                                            maxMenuHeight={150}
                                            closeMenuOnSelect={true}
                                            onChange={(val) => {
                                                let groups_local = [...selected_groups];
                                                groups_local[groups_index_local] = {
                                                    ...groups_local[groups_index_local],
                                                    group_id: val.value
                                                };
                                                this.setState({selected_groups: groups_local});
                                                this.props.groupsUpdate(groups_local);
                                            }}
                                        />
                                        <div className={classes.DeleteGroup}>
                                            <Button className={classes.DeleteGroupButton} size="sm" variant={"outline-danger"} onClick={() => {
                                                let filtered_array = selected_groups.filter((value,index,array) => {
                                                    return index !== (groups_index_local)
                                                });
                                                this.setState({selected_groups: filtered_array});
                                                this.props.groupsUpdate(filtered_array);
                                            }}>X</Button>
                                        </div>
                                        <Select
                                            className={classes.GroupSelect}
                                            defaultValue={{
                                                value: selected_groups[groups_index_local].group_user_type_id,
                                                label: selected_groups[groups_index_local].group_user_type_name,
                                                isFixed: true,
                                                isDisabled: true
                                            }}
                                            options={groupUserTypeOptions}
                                            maxMenuHeight={200}
                                            closeMenuOnSelect={true}
                                            onChange={(val) => {
                                                let groups_local = [...selected_groups];
                                                groups_local[groups_index_local] = {
                                                    ...groups_local[groups_index_local],
                                                    group_user_type_id: val.value
                                                };
                                                this.setState({selected_groups: groups_local});
                                                this.props.groupsUpdate(groups_local);
                                            }}
                                        />
                                        {group_manager_checkbox}
                                    </div>
                                );
                                groups_index++;
                                return group_jsx;
                            })}
                        </dd>
                    </>
                );
            }
        }
        let new_group_jsx = '';
        if (this.state.new_group === true) {
            new_group_jsx = (<NewGroup
                groups={this.state.groups}
                newGroupToggle={this.newGroupToggle}
                onNewGroup={this.newGroupsHandler}
            />);
        }
        const join_disabled = (this.state.new_group || this.state.selected_groups.filter(group => group.group_id === null).length !== 0);

        return (
            <dl className="row">
                <dt className="col-sm-3"><label>Groups</label></dt>
                {groupsInputElement}
                {new_group_jsx}
                <div style={{display: 'flex', justifyContent: 'space-between', width: "100%"}}>
                <dd className="col-sm-6"><Button className="col-sm-12" variant="outline-primary" onClick={this.addGroup} disabled={join_disabled}>Join A Group</Button></dd>
                <dd className="col-sm-6"><Button className="col-sm-12" variant="outline-secondary" onClick={this.newGroupToggle} disabled={this.state.new_group}>Create New Group</Button></dd>
                </div>
            </dl>
        );
    }
}

export default GroupsInput;